export const capitalizeFirstLetter = (word: string): string => word[0].toUpperCase() + word.substring(1)
